import { ReactNode } from 'react';
import BottomNavigationBar from '../BottomNavigator';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Typography, Box, Avatar, Stack } from '@mui/material';

const MainLayout = ({ children, title }: { children: ReactNode; title?: string }) => {
  const navigate = useNavigate();
  const canGoBack = window.history.length > 1;
  return (
    <div>
      <main>{children}</main>
      <BottomNavigationBar />
    </div>
  );
};

export default MainLayout;
